import { render } from "./BooksView.vue?vue&type=template&id=195f1bb0&scoped=true&lang=html"
import script from "./BooksView.vue?vue&type=script&lang=js"
export * from "./BooksView.vue?vue&type=script&lang=js"

import "./BooksView.vue?vue&type=style&index=0&id=195f1bb0&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195f1bb0"]])

export default __exports__